import axios from "axios";
import errorHandler from "../utils/errorHandler.js";
import {
    GET_PRE_SIGNED_URL,
    MEDIA_URL,
    UAC_URL,
    JOB_URL,
    GET_MEMBERSHIP_REPORT_URL,
    GET_LOAN_APPLICATION_REPORT_URL,
    GET_APPLICANT_REPORT_URL,
    GET_FINANCE_REPORT_URL,
    GET_LOAN_REPORT_URL,
    COMPANY_URL,
    SYNC_URL,
    USER_URL,
    NOTICEBOARD_URL,
    GET_LIVE_ACCOUNT_URL,
    GET_USER_URL,
    PAYOUT_URL,
    OPPORTUNITY_URL,
    INVESTMENT_URL, GET_INVESTMENT_REPORT_URL, GET_GRANT_REPORT_URL
} from "../api";
import {ADMINISTRATIVE, TIME} from "../stores/app.js";

export const getMembershipReport = () => {
    return axios.get(GET_MEMBERSHIP_REPORT_URL).then((response) => {
        return {
            payload: response.data,
            error: false
        };
    }).catch((error) => {
        errorHandler(error, "top-right");
        return {
            payload: error,
            error: true
        }
    });
};

export const getLoanApplicationReport = () => {
    return axios.get(GET_LOAN_APPLICATION_REPORT_URL).then((response) => {
        return {
            payload: response.data,
            error: false
        };
    }).catch((error) => {
        errorHandler(error, "top-right");
        return {
            payload: error,
            error: true
        }
    });
};

export const getApplicantReport = () => {
    return axios.get(GET_APPLICANT_REPORT_URL).then((response) => {
        return {
            payload: response.data,
            error: false
        };
    }).catch((error) => {
        errorHandler(error, "top-right");
        return {
            payload: error,
            error: true
        }
    });
};

export const getInvestmentReport = () => {
    return axios.get(GET_INVESTMENT_REPORT_URL).then((response) => {
        return {
            payload: response.data,
            error: false
        };
    }).catch((error) => {
        errorHandler(error, "top-right");
        return {
            payload: error,
            error: true
        }
    });
}

export const getLoanReport = () => {
    return axios.get(GET_LOAN_REPORT_URL).then((response) => {
        return {
            payload: response.data,
            error: false
        };
    }).catch((error) => {
        errorHandler(error, "top-right");
        return {
            payload: error,
            error: true
        }
    });
}

export const getGrantReport = () => {
    return axios.get(GET_GRANT_REPORT_URL).then((response) => {
        return {
            payload: response.data,
            error: false
        };
    }).catch((error) => {
        errorHandler(error, "top-right");
        return {
            payload: error,
            error: true
        }
    });
}

export const sync = () => {
    return function(dispatch) {
        return axios.get(SYNC_URL).then(async(response) => {
            await Promise.all([
                await dispatch(ADMINISTRATIVE({administrative: response.data.administrative})),
                await dispatch(TIME({time: response.data.time}))
            ]);

            return {
                error: false
            }
        }).catch((error) => {
            return errorHandler(error);
        });
    }
}

export const getUser = (id) => {
    return axios.get(GET_USER_URL(id)).then((response) => {
        return {
            payload: response.data,
            error: false
        }
    }).catch((error) => {
        errorHandler(error, "top-right");
        return {
            payload: null,
            error: true
        }
    });
}

export const user = (method, data) => {
    return axios({method: method, url: USER_URL, data: data}).then((response) => {
        return {
            payload: response.data.payload,
            error: false
        }
    }).catch((error) => {
        errorHandler(error, "top-right");
        return {
            payload: null,
            error: true
        }
    });
}

export const searchOrderNumber = () => {

}

export const admin = (method, data) => {
    return axios({method: method, url: UAC_URL, data: data}).then((response) => {
        return {
            payload: response.data.payload,
            error: false
        }
    }).catch((error) => {
        errorHandler(error, "top-right");
        return {
            payload: null,
            error: true
        }
    });
}

export const getPreSignedUrl = () => {
    return axios.get(GET_PRE_SIGNED_URL).then((response) => {
        return {
            error: false,
            payload: response.data
        }
    }).catch((error) => {
        errorHandler(error, "top-right");
        return {
            payload: error,
            error: true
        }
    });
}

export const uploadPhoto = (signed_url, binary, config) => {
    return fetch(signed_url, {
        method: 'PUT',
        body: binary,
        headers: config,
    }).then(response => {
        return {
            payload: response,
            error: false
        }
    }).catch(error => {
        errorHandler(error, "top-right");
        return {
            payload: error,
            error: true
        }
    });
}

export const media = (method, data) => {
    return axios({method: method, url: MEDIA_URL, data: data}).then((response) => {
        return {
            payload: response.data.message,
            error: false
        }
    }).catch((error) => {
        errorHandler(error, "top-right");
        return {
            payload: null,
            error: true
        }
    });
};

export const investment = (method, data) => {
    return axios({method: method, url: INVESTMENT_URL, data: data}).then((response) => {
        return {
            payload: response.data.message,
            error: false
        }
    }).catch((error) => {
        errorHandler(error, "top-right");
        return {
            payload: null,
            error: true
        }
    });
};

export const getFinanceReport = (data) => {
    return axios.post(GET_FINANCE_REPORT_URL, data).then((response) => {
        return {
            payload: response.data,
            error: false
        };
    }).catch((error) => {
        errorHandler(error, "top-right");
        return {
            payload: error,
            error: true
        }
    });
}

export const message = (method, data) => {
    return axios({method: method, url: INVESTMENT_URL, data: data}).then((response) => {
        return {
            payload: response.data.message,
            error: false
        }
    }).catch((error) => {
        errorHandler(error, "top-right");
        return {
            payload: null,
            error: true
        }
    });
};

export const payout = (method, data) => {
    return axios({method: method, url: PAYOUT_URL, data: data}).then((response) => {
        return {
            payload: response.data.message,
            error: false
        }
    }).catch((error) => {
        errorHandler(error, "top-right");
        return {
            payload: null,
            error: true
        }
    });
};

export const liveAccount = () => {
    return axios.get(GET_LIVE_ACCOUNT_URL).then((response) => {
        return {
            payload: response.data.payload,
            error: false
        };
    }).catch((error) => {
        errorHandler(error, "top-right");
        return {
            payload: error,
            error: true
        }
    });
}

export const company = (method, data) => {
    return axios({method: method, url: COMPANY_URL, data: data}).then((response) => {
        return {
            payload: response.data.message,
            error: false
        }
    }).catch((error) => {
        errorHandler(error, "top-right");
        return {
            payload: null,
            error: true
        }
    });
};

export const opportunity = (method, data) => {
    return axios({method: method, url: OPPORTUNITY_URL, data: data}).then((response) => {
        return {
            payload: response.data.message,
            error: false
        }
    }).catch((error) => {
        errorHandler(error, "top-right");
        return {
            payload: null,
            error: true
        }
    });
};

export const noticeboard = (method, data) => {
    return axios({method: method, url: NOTICEBOARD_URL, data: data}).then((response) => {
        return {
            payload: response.data.message,
            error: false
        }
    }).catch((error) => {
        errorHandler(error, "top-right");
        return {
            payload: null,
            error: true
        }
    });
};

export const job = (method, data) => {
    return axios({method: method, url: JOB_URL, data: data}).then((response) => {
        return {
            payload: response.data.message,
            error: false
        }
    }).catch((error) => {
        errorHandler(error, "top-right");
        return {
            payload: null,
            error: true
        }
    });
};
